import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';
import {
  AbsenceService,
  ClaimService,
  CommCenterService,
  ConfigurationService,
  DisplayService,
  DynamicEventBindService,
  InpageAliasService,
  LogService,
  Session,
  UserRoleService,
} from '../..';
import { MyClaim, NotificationItem, getUrlParams } from '../../../shared';
import { OutboundSSO, UserActions } from '../../../shared/models/user';
import { UserActionService } from '../../../shared/services/user-action.service';
import { OutboundSsoService } from '../../services/outbound-sso.service';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { ReportNewClaimComponent } from '../report-new-claim/report-new-claim.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-manager-reminders',
    template: `
    <!-- mobile view -->
    <div #dynamicContentContainer>
      <div class="tw-items-start tw-w-full tw-flex tw-flex-wrap lg:tw-hidden">
        <div class="tw-w-full">
          <ng-container *ngTemplateOutlet="reminders"></ng-container>
        </div>
        <div class="tw-w-full">
          <ng-container *ngTemplateOutlet="links"></ng-container>
        </div>
      </div>
    
      <div class="tw-items-start tw-w-full tw-hidden lg:tw-flex">
        <div class="tw-px-4  tw-flex-none ">
          <img [src]="imageName" width="194" height="193" alt="" />
        </div>
        <div class="app-pr2 tw-grow tw-h-full">
          <ng-container *ngTemplateOutlet="reminders"></ng-container>
        </div>
        <div class=" side-border app-pr3 app-pb2">
          <ng-container *ngTemplateOutlet="links"></ng-container>
        </div>
      </div>
    
      <ng-template #reminders>
        <app-loading-panel
          [state]="loaded ? 'Loaded' : 'Loading'"
          class="tw-h-full"
          >
          <ng-template #content>
            <div class="tw-w-full">
              <span style="font-weight: bold;font-size: 18px"
                >{{'Hello' | translation : translationRequest}} {{ currentUserName | titlecase }}</span
                >@if (!hasClaims && !hasReminders) {
                <span
                  style="font-weight: normal;font-size: 18px"
                  >,</span
                  >
                }
                <!--Adding a role check for controller as a part of bug fix #204027 -->
                @if (
                  !hasReminders && hasClaims && this.accommodationsCount === 0
                  ) {
                  <span
                    style="font-weight: normal;font-size: 18px"
                    >, @if(role !== 'CONTROLLER') {
                    {{ ("there are currently no important  reminders for your" | translation : translationRequest) + ' ' + employeeAlias + "(s)' " + ("claim(s)." | translation : translationRequest) }}
                    @if (!hasClaims) {
                      <a
                        tabindex="0"
                        (click)="quickLinksClick('LearningCenter', 'Learning Center')"
                  (keydown.enter)="
                    quickLinksClick('LearningCenter', 'Learning Center')
                  "
                        >{{'learn about claims'  | translation : translationRequest}}</a
                        >
                        }} @if(role === 'CONTROLLER') { {{'do you want to' | translation:translationRequest }}
                        <a
                          tabindex="0"
                          role="button"
                  (keydown.enter)="
                    quickLinksClick('ReportNewClaim', 'Report New Claim')
                  "
                  (click)="
                    quickLinksClick('ReportNewClaim', 'Report New Claim')
                  "
                          >{{ reportClaimLabel }}
                        </a>
                        {{'or' | translation : translationRequest}}
                        <a
                          tabindex="0"
                          (click)="quickLinksClick('LearningCenter', 'Learning Center')"
                  (keydown.enter)="
                    quickLinksClick('LearningCenter', 'Learning Center')
                  "
                          >{{'learn about claims'  | translation : translationRequest}}</a
                          >
                          ?}
                        </span>
                      }
                      @if (
                        hasReminders ||
                        (this.accommodationsCount > 0 && !hasReminders)
                        ) {
                        <span
                          style="font-weight: normal;font-size: 18px"
                          >, {{'here are some important reminders.'  | translation : translationRequest}}
                        </span>
                      }
                      @if (!hasReminders) {
                        <span
                          style="font-weight: normal;font-size: 18px"
                          >
                          @if(!hasClaims){ {{'do you want to' | translation : translationRequest}} }
                            @if (hasReportClaim && !hasClaims) {
                              <a
                                tabindex="0"
                  (keydown.enter)="
                    quickLinksClick('ReportNewClaim', 'Report New Claim')
                  "
                  (click)="
                    quickLinksClick('ReportNewClaim', 'Report New Claim')
                  "
                                >{{ reportClaimLabel }}</a
                                >
                              }
                              @if(hasReportClaim && !hasClaims){ {{'or' | translation : translationRequest}}  }
                                @if (!hasClaims) {
                                  <a
                                    tabindex="0"
                                    (click)="quickLinksClick('LearningCenter', 'Learning Center')"
                  (keydown.enter)="
                    quickLinksClick('LearningCenter', 'Learning Center')
                  "
                                    >{{'learn about claims' | translation : translationRequest}}</a
                                    >
                                  }
                                  @if(!hasClaims){?}
                                  </span>
                                }
                                <div class="tw-list-disc app-pl3 app-pt2" style="font-size: 16px">
                                  <ng-container class="tw-w-full">
                                    <ul
                                      class="tw-list-disc app-pl3 app-pt1"
                                      style="font-size: 16px"
                                      >
                                      @if (showReminders()) {
                                        <div>
                                          @for (
                                            reminder of managerActivities
                                            ?.managerRemindersList?.managerReminders; track
                                            reminder; let i = $index) {
                                            <li
                                              class="list-item"
                                              [innerHTML]="reminder.message"
                                              [attr.data-index]="i"
                                            ></li>
                                          }
                                        </div>
                                      }
                                      @if (this.accommodationsCount > 0 && hasReminders) {
                                        <li
                                          class="list-item"
                                          >
                                          <span
                                            >{{'Review is needed on'  | translation : translationRequest}}
                                            <a
                                              tabindex="0"
                          (click)="
                            redirectAccomdation(this.accommodationsCount)
                          "
                          (keydown.enter)="
                            redirectAccomdation(this.accommodationsCount)
                          "
                          [attr.aria-label]="
                            'Review '+
                            this.accommodationsCount +
                            ' accommodations' 
                          "
                          >{{ this.accommodationsCount | numberToWord | translation : translationRequest }}</a
                                              >
                                              {{'accommodation(s)' | translation : translationRequest}}.</span
                                              >
                                            </li>
                                          }
                                          @if (this.accommodationsCount > 0 && !hasReminders) {
                                            <li
                                              class="list-item"
                                              >
                                              <span
                                                >{{'Review is needed on' | translation : translationRequest}}
                                                <a
                                                  tabindex="0"
                          (click)="
                            redirectAccomdation(this.accommodationsCount)
                          "
                          (keydown.enter)="
                            redirectAccomdation(this.accommodationsCount)
                          "
                                                  >{{ this.accommodationsCount | numberToWord }}</a
                                                  >
                                                  {{'accommodation(s)' | translation : translationRequest}}.</span
                                                  >
                                                </li>
                                              }
                                            </ul>
                                          </ng-container>
                                        </div>
                                      </div>
                                    </ng-template>
                                  </app-loading-panel>
                                </ng-template>
                                <ng-template #dialogSelectClaim>
                                  <app-dialog
                                    [showActions]="false"
                                    [showHeader]="false"
                                    ariaLabel="{{'Select claim dialog'| sentenceCase}}"
                                    ariaLabelMessage="{{'Close announcement popup'| sentenceCase}}"
                                    >
                                    <app-claim-list-report-absence
                                      title="{{'Confirmation' | translation : translationRequest}}"
                                      [claims]="claims"
                                      [redirectToSmartly]="redirectToSmartly"
                                      >
                                    </app-claim-list-report-absence>
                                  </app-dialog>
                                </ng-template>
                                <ng-template #links>
                                  @if (outboundSSO !== undefined && outboundSSO !== null && outboundSSO.length > 0) {
                                    <ng-content>
                                      @for (outbound of outboundSSO; track outbound) {
                                        <div
                                          class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
                                          >
                                          @if (outbound.ssoLinkManager) {
                                            <img
                                              [src]="outbound.ssoLinkImage"
                                              height="30"
                                              width="30"
                                              class="tw-hidden lg:tw-block"
                                              alt="">
                                            }<img/>
                                            @if (outbound.ssoLinkManager) {
                                              <a
                                                class="big-link app-pl1"
                                                role="link"
                                                tabindex="0"
                                                (click)="quickLinksClick('OutboundSSO', 'Outbound SSO',outbound.ssoType)"
                                                (keydown.enter)="quickLinksClick('OutboundSSO', 'Outbound SSO',outbound.ssoType)"
                                              >{{ outbound.ssoLinkManager | translation: translationRequest }}</a>
                                            }
                                          </div>
                                        }
                                      </ng-content>
                                    }
                                    @if (hasReportClaim) {
                                      <div
                                        class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
                                        tabindex="-1"
                                        >
                                        <img
                                          src="./assets/images/Report_claim.png"
                                          height="30"
                                          width="30"
                                          class="tw-hidden lg:tw-block"
                                          alt=""
                                          />
                                          <a
                                            tabindex="0"
            (keydown.enter)="
              quickLinksClick('ReportNewClaim', 'Report New Claim')
            "
                                            class="big-link app-pl1"
                                            (click)="quickLinksClick('ReportNewClaim', 'Report New Claim')"
                                            role="button"
                                            >{{ reportClaimLabel }}</a
                                            >
                                          </div>
                                        }
                                        @if (showReportAbsence()) {
                                          <div
                                            class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
                                            tabindex="-1"
                                            >
                                            <img
                                              src="./assets/images/Intermittent_absence.png"
                                              height="30"
                                              width="30"
                                              class="tw-hidden lg:tw-block"
                                              alt=""
                                              />
                                              <a
                                                tabindex="0"
                                                class="big-link app-pl1"
                                                (click)="quickLinksClick('ReportAbsence', 'Report an Absence')"
            (keydown.enter)="
              quickLinksClick('ReportAbsence', 'Report an Absence')
            "
                                                role="button"
                                                >{{'Report an absence'| translation : translationRequest}}</a
                                                >
                                              </div>
                                            }
                                            @if (incidentalAbsences5) {
                                              <div
                                                class="tw-flex tw-items-center app-pt1 "
                                                >
                                                <img
                                                  src="./assets/images/Intermittent_absence.png"
                                                  height="30"
                                                  width="30"
                                                  class="tw-hidden lg:tw-block"
                                                  alt=""
                                                  />
                                                  <a
                                                    tabindex="0"
                                                    class="big-link app-pl1"
                                                    (click)="quickLinksClick('ViewAbsences', 'View Absence')"
                                                    (keydown.enter)="quickLinksClick('ViewAbsences', 'View Absence')"
                                                    >{{'View absences'| translation : translationRequest}}</a
                                                    >
                                                  </div>
                                                }
                                                @if (!isIncidentalClient) {
                                                  <div
                                                    class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
          (click)="
            quickLinksClick('CommunicationCenter', 'Communication Center')
          "
          (keydown.enter)="
            quickLinksClick('CommunicationCenter', 'Communication Center')
          "
                                                    tabindex="-1"
                                                    >
                                                    <img
                                                      src="./assets/images/Comm_center_icon.png"
                                                      height="30"
                                                      width="30"
                                                      class="tw-hidden lg:tw-block"
                                                      alt=""
                                                      />
                                                      <a
                                                        class="big-link app-pl1 mat-badge-accent"
                                                        [matBadge]="commCenterService.unreadMessageCount()"
                                                        matBadgeOverlap="false"
                                                        tabindex="0"
                                                        role="link"
                                                        >{{'Communication center'| translation : translationRequest}}</a
                                                        >
                                                      </div>
                                                    }
                                                    @if (hasLearningCenter) {
                                                      <div
                                                        class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
                                                        tabindex="-1"
                                                        >
                                                        <img
                                                          src="./assets/images/Helpful_resources_icon.png"
                                                          height="30"
                                                          width="30"
                                                          class="tw-hidden lg:tw-block"
                                                          alt=""
                                                          />
                                                          <a
                                                            tabindex="0"
                                                            role="link"
            (keydown.enter)="
              quickLinksClick('LearningCenter', 'Learning Center')
            "
                                                            class="big-link app-pl1"
                                                            (click)="quickLinksClick('LearningCenter', 'Learning Center')"
                                                            >{{'Helpful resources'| translation : translationRequest}}</a
                                                            >
                                                          </div>
                                                        }
                                                      </ng-template>
                                                    </div>
    `,
    styles: [
        `
      .side-border {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
        height: 100%;
        padding-left: 16px;
      }

      .list-item {
        padding-bottom: 12px;
      }

      .claimListDialog {
        width: 80%;
        height: auto;
        min-height: 'calc(100vh - 90px)';
      }
    `,
    ],
    standalone: false
})
export class ManagerRemindersComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  role: string = 'Manager';

  @Input()
  managerActivities: any;

  @Input()
  claims: MyClaim[];
  isMgrOwnClaims: boolean = false;
  @Input()
  commCenterMsgCount: number = 0;

  @Input()
  accommodationsCount: number = 0;
  
  @Output()
  filterApplied = new EventEmitter<boolean>();

  @Output()
  focusTab = new EventEmitter<string>();

  @Input()
    translationRequest: TranslationRequest;
  

  mappings: any;
  hasReportClaim: boolean = false;
  hasIntermittentAbsence: boolean = false;
  currentUserName: string;
  hasReminders: boolean = false;
  hasLearningCenter: boolean = false;
  maxBadgeCount = 99;
  loaded: boolean = false;
  originalNotifications: any;
  outboundSSO: OutboundSSO[] = [];
  hasOpenClaims: boolean = false;
  multipleOpenClaims: boolean = false;
  redirectToSmartly: boolean = true;
  isIncidentalClient: boolean = false;
  @ViewChild('dynamicContentContainer') container: ElementRef;
  @ViewChild('dialogSelectClaim') dialogSelectClaim: TemplateRef<any>;
  private unlistens: (() => void)[] = [];
  hasClaims: boolean;
  pendingAccomDationRemainder: string = '[count of pending accommodations]';
  managerViewDashboard: boolean;
  reportClaimLabel: string = '';
  incidentalAbsences5 = false;
  imageName: string = './assets/images/';
  employeeAlias: string;

  constructor(
    private session: Session,
    private bindEvents: DynamicEventBindService,
    private dialog: MatDialog,
    private display: DisplayService,
    private userAction: UserActionService,
    private router: Router,
    private userRole: UserRoleService,
    public outboundSsoService: OutboundSsoService,
    public claimConfigService: ConfigurationService,
    public commCenterService: CommCenterService,
    private route: ActivatedRoute,
    public claimService: ClaimService,
    public inpageAliasService: InpageAliasService,
    private absenceService: AbsenceService,
    public logService: LogService,
    private leaveLinkAccessService: LeaveLinkAccessService
  ) { }

  subs = new SubSink();

  selectedUserName(){
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager'
    );

   if (filteredManagerInSession) {
      const filterInitialSupervisor = JSON.parse(
        filteredManagerInSession
      );
      
      if(filterInitialSupervisor.firstName != undefined && filterInitialSupervisor.firstName != null && filterInitialSupervisor.firstName.length > 2)
      {
        return filterInitialSupervisor.firstName;
      }
    }
   return this.session.user?.firstName;
  }

  async ngOnInit() {
    this.hasReportClaim = this.display.reportClaim;
    this.employeeAlias = await this.inpageAliasService.get('employeeSingular');
    this.reportClaimLabel = await this.inpageAliasService.get('ReportClaim');

    if (this.accommodationsCount > 0) {
      this.pendingAccomDationRemainder =
        this.pendingAccomDationRemainder.replace(
          '[count of pending accommodations]',
          this.accommodationsCount.toString()
        );
    }
    this.originalNotifications = [...this.managerActivities.notifications];    
    this.currentUserName = this.selectedUserName();
    this.hasIntermittentAbsence = this.display.reportIntermittentAbsence;
    this.hasLearningCenter = this.display.learningCenter;
    this.hasReminders =
      this.managerActivities?.managerRemindersList?.managerReminders.filter(
        (n: any) => n.message != null && n.message != undefined
      ).length > 0
        ? true
        : false;

    this.outboundSSO = this.display.outboundSSO;
    this.isMgrOwnClaims = this.route.snapshot.queryParamMap.get('emp') == null; //this.mgrAction == UserActions.ViewOwnEmpDb;

    const params = getUrlParams();
    this.managerViewDashboard =
      (window.location.pathname === '/dashboard' ||
        window.location.pathname === '/controller') &&
      !params.emp;
    this.hasClaims =
      !this.managerViewDashboard || this.claims?.length > 0 ? true : false;

    if (this.managerViewDashboard) {
      this.imageName = this.imageName + 'Manager_View_Icon.webp';
    } else if (params.emp) {
      // Manager viewing employee's claim
      this.imageName =
        this.imageName + '053726-mySedgwick_Helpful_Link_Characters_4.png';
    } else {
      this.imageName = this.imageName + 'Manager_View_Icon.webp';
    }
    this.loaded = true;
    this.isIncidentalClient = this.claimConfigService.getFeatureAccess(
      'SUBMITINTERMITTENTABSENCES'
    );
    this.mappings = [
      {
        selector: '.act-on-reminder',
        action: this.actOnReminders.bind(this),
      },
    ];
    // moving the below block from ngViewAfterinit to oninit as this was affecting the dynamic binding of events

    this.incidentalAbsences5 = this.claimConfigService.getConfigFeatureAccess(
      'IncidentalAbsences5'
    );

    this.checkOpenClaims();
  }

  quickLinksClick(featureName: string, tabName: string, ssoType: string = '') {
    let ssoLabel = ' - ';

    if (this.outboundSSO != null && ssoType != null && ssoType != undefined && ssoType.length > 2) {
      ssoLabel = ssoLabel + ssoType.toUpperCase();
    }
    tabName = tabName + (featureName == 'OutboundSSO' ? ssoLabel : '');
    this.LogFeature(featureName, tabName, 'Manager View QuickLinks');
    if (featureName == 'ReportNewClaim') {
      this.reportClaim();
    } else if (featureName == 'ReportAbsence') {
      this.selectClaim();
    } else if (featureName == 'ViewAbsences') {
      this.navigateToAbsences();
    } else if (featureName == 'CommunicationCenter') {
      this.router.navigate(['/communication-center'], {});
    } else if (featureName == 'LearningCenter') {
      this.redirectToLearningCenter();
    } else if (featureName == 'OutboundSSO') {
      if (this.outboundSSO != undefined && this.outboundSSO != null && this.outboundSSO.length > 0) {
        const ssoIndex = this.outboundSSO.findIndex(x => x.ssoType.toLowerCase() == ssoType.toLowerCase());
        if (ssoIndex > -1) {
          if (ssoType.toLowerCase() === 'leavelink') {
            this.leaveLinkAccessService.handleLeaveLinkAccess();
          } else {
           this.outboundSsoService.showConfirmationDialog(
              this.outboundSSO[ssoIndex].ssoType,
              this.outboundSSO[ssoIndex].ssoEndPoint
            );
            
          }
        }
      }
    }
  }

  LogFeature(featureName: string, tabName: string, linkArea: string) {
    this.logService.LogFeature(
      undefined,
      featureName,
      linkArea + ' - ' + tabName
    );
  }

  async ngAfterViewInit() {
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));
      if ((await this.checkReminders()) && this.container) {
        this.unlistens = await this.bindEvents.bindDynamicEvents(
          this.container,
          this.mappings
        );
      }
    } catch (error) {
      console.error('Error binding dynamic events:', error);
    }
  }

  checkReminders(): boolean {
    return (
      this.managerActivities?.managerRemindersList?.managerReminders.filter(
        (n: any) => n.message != null && n.message != undefined
      ).length > 0
    );
  }

  showReminders() {
    return this.accommodationsCount > 0 || this.checkReminders();
  }

  setupMapping() {
    this.mappings = [
      {
        selector: '.act-on-reminder',
        action: this.actOnReminders.bind(this),
      },
    ];
  }

  async actOnReminders(event: MouseEvent) {
    const element = event.currentTarget as HTMLElement;
    const reminderIndex = element.parentElement?.getAttribute('data-index')
      ? element.parentElement.getAttribute('data-index')
      : null;
    const intIdx = reminderIndex ? parseInt(reminderIndex) : 0;
    const reminder =
      this.managerActivities.managerRemindersList.managerReminders[intIdx];
    this.LogFeature(
      'ImportantReminder',
      reminder.type + ' - Count = ' + reminder.claimKeys.length,
      'Manager Reminder '
    );
    if (reminder.type === 'RTW_CONFIRMATION_RM') {
      if (reminder.claimKeys.length == 1) {
        let alert;
        if (this.managerActivities && this.managerActivities.returnToWork) {
          if (reminder && reminder.alertMasterIds.length > 0) {
            alert = this.managerActivities.returnToWork.find(
              (al: { alertMasterId: any }) =>
                al.alertMasterId === reminder.alertMasterIds[0]
            );
          }
        }
        this.router.navigate(['/confirm-return-to-work'], {
          queryParams: {
            claimId: alert.claimId,
            source: alert.source,
            rtw: 'confirm',
            rtwType: alert.rtwType,
            alertMasterUid: alert.alertMasterId,
            type: alert.type,
            rtwDate: this.userRole.supervisor
              ? alert.rtwDate
              : this.userRole.omni || this.userRole.overseer
                ? alert.rtwDate
                : '',
          },
        });
      }
      if (reminder.claimKeys.length > 1) {
        this.focusTab.emit('returntowork');
      }
    } else if (reminder.type === 'MEDDOC_NEEDED_AM') {
      this.filterNotifications(reminder);
    }
  }
  filterNotifications(reminder: any) {
    this.loaded = false;
    const filteredNotifications = this.originalNotifications.filter(
      (notificationItem: NotificationItem) =>
        reminder.alertMasterIds.includes(notificationItem.alertId)
    );
    if (filteredNotifications.length > 0) {
      this.managerActivities.notifications = [...filteredNotifications];
      this.scrollToNotification();
    }
    this.filterApplied.emit(true);
    this.focusTab.emit('Notifications');
    this.loaded = true;
  }

  scrollToNotification() {
    const notification = document.getElementById('mgrActivityPnl');
    if (notification != null) {
      notification.scrollIntoView();
    }
  }

  reportClaim() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Confirmation',
    };
    const dlg = this.dialog.open(ReportNewClaimComponent, dialogConfig);
    dlg.addPanelClass('app-dlg-padding');
    dlg.updateSize('700px', '450px');
  }

  reportIntermittentAbsence() { }

  checkOpenClaims() {
    let count: number = 0;
    if (!this.claims) {
      return;
    }
    this.claims.forEach(function (claim) {
      if (
        claim.status === 'Open' &&
        claim.lineOfBusiness === 'LV' &&
        claim.claimDescription.toLowerCase().indexOf('intermittent') > -1
      ) {
        count++;
      }
    });
    if (count > 0) {
      this.hasOpenClaims = true;
    }
    if (count > 1) {
      this.multipleOpenClaims = true;
    }
  }

  showReportAbsence() {
    if (!this.claims) {
      return false;
    } else {
      return (
        this.claims.findIndex(
          (claim) =>
            claim.status === 'Open' &&
            claim.lineOfBusiness === 'LV' &&
            claim.isIntermittent &&
            claim.claimLevelFeatures.indexOf('submitintermittentabsences') > -1
        ) > -1 && this.display.reportIntermittentAbsence
      );
    }
  }

  selectClaim() {
    if (this.claimConfigService.getConfigFeatureAccess('leavelinksso')) {
      this.claimService.loadIntermittentAbsence('', '', null);
    } else {
      if (this.hasOpenClaims) {
        if (this.multipleOpenClaims) {
          this.redirectToSmartly = false;
          this.dialog.open(this.dialogSelectClaim, {
            panelClass: 'claimListDialog',
          });
        } else {
          const queryParams: any = {};
          const element = this.claims.find(
            (claim) =>
              claim.status === 'Open' &&
              claim.lineOfBusiness === 'LV' &&
              claim.claimDescription.toLowerCase().indexOf('intermittent') > -1
          );
          queryParams.claimId = element.claimId;
          queryParams.source = element.source;
          this.userAction.setClaimant(element);
          this.router.navigate(['/reportanabsence'], {
            queryParams,
          });
        }
      }
    }
  }

  UnreadMsgCount() {
    return this.commCenterMsgCount > 99
      ? this.maxBadgeCount
      : this.commCenterMsgCount;
  }

  setCommCenterFocus() {
    const commcenter = document.getElementById('commCenterPnl');
    if (commcenter != null) {
      commcenter.scrollIntoView();
    }
  }

  redirectToLearningCenter() {
    this.userAction.setAction(UserActions.ViewOwnMgrDb);
    this.route.url.subscribe((urlSegments) => {
      if (urlSegments.length > 0) {
        const firstPathSegment = urlSegments[0].path;
        this.router.navigate(['help'], {
          queryParams: {
            focus: 'learningcenter',
            origin: firstPathSegment,
          },
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.unlistens.forEach((unlisten) => unlisten());
    this.subs.unsubscribe();
  }
  redirectAccomdation(count: number) {
    this.LogFeature(
      'ImportantReminder',
      'count - ' + count,
      'Manager Reminder '
    );
    this.focusTab.emit('accommodations');
  }

  navigateToAbsences() {
    if (location.pathname === '/supervisor') {
      // supervisor dashboard, navigate to off work
      this.router.navigate(['/absence-dashboard'], {
        queryParams: {
          focus: 'offWork',
        },
      });
    } else if (this.claims.length > 0) {
      // employee view, navigate to employee's absences
      const claim = this.claims[0];
      this.absenceService.navigateToAbsences(
        claim.empUnum,
        claim.name,
        claim.hrMasterUid,
        claim.empUnum,
        claim.encryptedEmpId
      );
    } else {
      const claimant = this.userAction.getClaimant();
      this.absenceService.navigateToAbsences(
        claimant?.empId,
        claimant?.name,
        claimant?.hrMasterUid,
        claimant?.empUnum,
        claimant?.maskedEmpId
      );
    }
  }
}
